import { render, staticRenderFns } from "./BillingModel.vue?vue&type=template&id=594947f5&"
import script from "./BillingModel.vue?vue&type=script&lang=ts&"
export * from "./BillingModel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports